import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ClsArrPipe } from "@app/utils/cls-arr.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { CopyLinkComponent } from "@app/copy-link/copy-link.component"

@Component({
	selector: "app-cc-params-user-details",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		ClsArrPipe,
		GenInputComponent,
		ModalWrapComponent,
		CopyLinkComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<h4 class="gen-title section-title">
				@if (permsService.owner_has_users) {
					{{ "multiuserdetails" | langVal }}
				} @else {
					{{ "userdetails" | langVal }}
				}
			</h4>

			@for (rowFields of rows; track rowFields) {
				<div class="row">
					@for (field of rowFields; track field) {
						<div
							[className]="
								[
									'col-' + (field?.xs || clsDefaults.xs),
									'col-md-' + (field?.md || clsDefaults.md),
								] | clsArr
							"
						>
							<label>{{ field?.lang || field.name | langVal }}</label>
							<app-gen-input
								[tabindex]="field?.tabIndex"
								[className]="[field.name === 'email' && 'email'] | clsArr"
								[actualObj]="configcliniq"
								[errors]="errors"
								[fieldName]="field.name"
								[title_ph_lang]="field?.lang || field.name"
								(changeEvent)="validateAndSave()"
							></app-gen-input>
						</div>
					}
				</div>
			}
			<div
				titleLang="affiliate_header"
				class="followup-title"
			>
				{{ "affiliate_header" | langVal }}
			</div>
			<div titleLang="affiliate_link">
				<button
					class="btn btn-primary my-2"
					preIcon="copy"
					titleLang="affiliate_link"
					tabindex="-1"
					(click)="openAffiliateLink()"
				>
					{{ "affiliate_link" | langVal }}
				</button>
			</div>
		</div>
		@if (modalProps) {
			<app-modal-wrap
				(onClose)="modalProps = null"
				modalWrapperClass="modal-small-width"
				title="affiliate_header"
			>
				<app-copy-link
					(onClose)="modalProps = null"
					[link]="modalProps.link"
				/>
			</app-modal-wrap>
		}
	`,
})
export class CcParamsUserDetailsComponent extends CcParamsGen {
	modalProps: any = null
	saveObjName: string = "user"
	validationFields: any = {
		name: { not_empty: null },
		email: { not_empty: null },
	}

	clsDefaults: any = { xs: 6, md: 3 }
	tabIndexStart: number = 51
	rows: any[] = [
		[
			{ name: "name", xs: 12 },
			{ name: "title", lang: "user_title", xs: 12 },
			// {name:"name_on_invoice",lang:"name_on_invoice",xs:12},
		],
		[
			{ name: "profession", xs: 12 },
			{ name: "license_number", xs: 12 },
		],
		[
			{ name: "street" },
			{ name: "house", md: 1 },
			{ name: "city" },
			{ name: "zip", md: 2 },
		],
		[{ name: "phone" }, { name: "fax" }, { name: "email" }],
	]
	ngOnInit() {
		let curTabIndex = this.tabIndexStart
		this.rows.forEach((rowFields) => {
			rowFields.forEach((field) => {
				field.tabIndex = curTabIndex
				curTabIndex++
			})
		})
	}
	openAffiliateLink() {
		this.modalProps = {
			name: "copy-link",
			link: `${location.origin}/regi/regi?affiliate_user_id=${this.store.cc()?.aff_code}`,
		}
	}
}
